import { useState } from 'react';
import { useAuthorization } from 'framework/authorization';
import { AddressableViewLayout } from 'framework/ViewTypes';
import { RecruitmentPoolFormDrawer } from '../createupdate';
import { RECRUITMENT_POOL_UPDATE } from '../constants';
import { RECRUITING_SOURCING_SEARCH } from '../sourcing/constants';
import { useRecruitmentPoolUrl } from '../routing';
import type { RecruitmentPoolStatus } from '../types';
import useRecruitmentPoolService from '../useRecruitmentPoolService';
import RecruitmentPoolDetailsContent from './details/RecruitmentPoolDetailsContent';
import useRecruitmentPoolDetails from './model/useRecruitmentPoolDetails';

const RecruitmentPoolDetailsPage = () => {
  const { isGranted } = useAuthorization();
  const { recruitmentPool, isLoading, error, reload, setRecruitmentPool } = useRecruitmentPoolDetails();
  const { getSourcingUrl } = useRecruitmentPoolUrl();
  const { transit } = useRecruitmentPoolService();
  const [isEditOpen, setEditOpen] = useState(false);

  const changeStatus = async (status: RecruitmentPoolStatus) => {
    if (!recruitmentPool) return;

    const updatedPool = await transit(recruitmentPool.id, status);
    setRecruitmentPool(updatedPool);
  };

  return (
    <AddressableViewLayout
      loading={isLoading}
      contentLayout={
        <RecruitmentPoolDetailsContent
          recruitmentPool={recruitmentPool}
          loading={isLoading}
          error={error}
          retry={reload}
          canUpdate={isGranted(RECRUITMENT_POOL_UPDATE)}
          canSource={isGranted(RECRUITING_SOURCING_SEARCH)}
          onEdit={() => setEditOpen(true)}
          onTransit={status => void changeStatus(status)}
          onSourcing={() => {
            if (recruitmentPool) {
              window.open(getSourcingUrl(recruitmentPool.id), '_blank', 'noopener,noreferrer');
            }
          }}
        />
      }
      drawer={
        recruitmentPool ? (
          <RecruitmentPoolFormDrawer
            isOpen={isEditOpen}
            onClose={() => setEditOpen(false)}
            recruitmentPool={recruitmentPool}
            onSuccess={updatedPool => {
              setRecruitmentPool(updatedPool);
              setEditOpen(false);
            }}
          />
        ) : undefined
      }
    />
  );
};

export default RecruitmentPoolDetailsPage;
